import React, {MouseEvent} from "react";

import {Button} from "@pg-design/button-module";
import {w100} from "@pg-design/helpers-css";

import {useAppSelector} from "../../../../store/hooks";
import {ViewType} from "../../../../view_type/ViewType";
import {IReelActionButtonType} from "../../../types/IReelActionButtonType";
import {IReelDetails} from "../../../types/IReelDetails";
import {ReelDetailsInquiryFormButton} from "./ReelDetailsInquiryFormButton";

interface IProps {
    reel: IReelDetails;
    onBtnClick?(event?: MouseEvent): void;
    onInquiryFormModalOpen?(): void;
    onInquiryFormModalClose?(): void;
}

export const ReelDetailsCtaButton = (props: IProps) => {
    const {reel} = props;

    const viewType = useAppSelector((state) => state.viewType.current);

    if (reel.action_button_type === IReelActionButtonType.CustomUrl && viewType !== ViewType.OFFER && viewType !== ViewType.PROPERTY) {
        return (
            <Button
                href={reel.action_button_url || ""}
                target="_blank"
                type="button"
                variant="outlined_secondary"
                size="x-small"
                css={[w100]}
                onClick={props.onBtnClick}
            >
                {reel.action_button_name}
            </Button>
        );
    }

    const customUrlOnOfferOrPropertyDetail =
        reel.action_button_type === IReelActionButtonType.CustomUrl && (viewType === ViewType.OFFER || viewType === ViewType.PROPERTY);

    if (reel.action_button_type === IReelActionButtonType.InquiryForm || customUrlOnOfferOrPropertyDetail) {
        return (
            <ReelDetailsInquiryFormButton
                reel={reel}
                onInquiryFormModalOpen={() => {
                    props.onBtnClick?.();
                    props.onInquiryFormModalOpen?.();
                }}
                onInquiryFormModalClose={props.onInquiryFormModalClose}
            />
        );
    }

    return null;
};
import React, {MouseEvent} from "react";

import {Button} from "@pg-design/button-module";
import {w100} from "@pg-design/helpers-css";

import {useAppSelector} from "../../../../store/hooks";
import {ViewType} from "../../../../view_type/ViewType";
import {IReelActionButtonType} from "../../../types/IReelActionButtonType";
import {IReelDetails} from "../../../types/IReelDetails";
import {ReelDetailsInquiryFormButton} from "./ReelDetailsInquiryFormButton";

interface IProps {
    reel: IReelDetails;
    onBtnClick?(event?: MouseEvent): void;
    onInquiryFormModalOpen?(): void;
    onInquiryFormModalClose?(): void;
}

export const ReelDetailsCtaButton = (props: IProps) => {
    const {reel} = props;

    const viewType = useAppSelector((state) => state.viewType.current);

    if (reel.action_button_type === IReelActionButtonType.CustomUrl && viewType !== ViewType.OFFER && viewType !== ViewType.PROPERTY) {
        return (
            <Button
                href={reel.action_button_url || ""}
                target="_blank"
                type="button"
                variant="outlined_secondary"
                size="x-small"
                css={[w100]}
                onClick={props.onBtnClick}
            >
                {reel.action_button_name}
            </Button>
        );
    }

    const customUrlOnOfferOrPropertyDetail =
        reel.action_button_type === IReelActionButtonType.CustomUrl && (viewType === ViewType.OFFER || viewType === ViewType.PROPERTY);

    if (reel.action_button_type === IReelActionButtonType.InquiryForm || customUrlOnOfferOrPropertyDetail) {
        return (
            <ReelDetailsInquiryFormButton
                reel={reel}
                onInquiryFormModalOpen={() => {
                    props.onBtnClick?.();
                    props.onInquiryFormModalOpen?.();
                }}
                onInquiryFormModalClose={props.onInquiryFormModalClose}
            />
        );
    }

    return null;
};
